import { User } from 'domain/user'

export const emptyUser: User = {
  id: '',
  clientId: '',
  name: '',
  login: '',
  password: '',
  email: '',
  phoneNumber: '',
  lastLogin: new Date(),
  active: true,
  blocked: false,
  mainContactPerson: false,
}
